module.exports = __webpack_public_path__ + "static/media/distribution.a60c4053.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Mozilla/DesignTokens/distribution.png
// module id = ./src/assets/Mozilla/DesignTokens/distribution.png
// module chunks = 0